// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"deliveryLabel___wrapper___BdqhR","wrapper--hovered":"deliveryLabel___wrapper--hovered___16Ha5"};